import { createSelector } from "reselect";

const ashaAnmActiveInactiveCount = (state) =>
  state.ashaAnmSection.activeInactiveCount;
const topPerformerData = (state) => state.ashaAnmSection.topPerformerData;
const ashaProfile = (state) => state.ashaAnmSection.ashaProfile;
const ashaScheme = (state) => state.ashaAnmSection.ashaSchemes;
const ashasOnIncentives = (state) => state.ashaAnmSection.ashasOnIncentives;
const incentiveData = (state) => state.ashaAnmSection.incentiveData;
const isLoading = (state) => state.ashaAnmSection.isLoading;
const globalAreaType = (state) => state.ashaAnmSection.areaType;
const totalAshaAnmTableList = (state) =>state.ashaAnmSection.totalAshaAnmTableList;
const paginationData = (state) => state.ashaAnmSection.paginationData;

const ashaDeployedTable = (state) => state.ashaAnmSection.ashaList;
const isDataLoading = (state) => state.ashaList.isLoading;

export const getTopPerformerData = createSelector(
  [topPerformerData],
  (data) => data
);
export const getIsLoading = createSelector([isLoading], (data) => data);
export const getAshaProfile = createSelector([ashaProfile], (data) => data);
export const getAshaScheme = createSelector([ashaScheme], (data) => data);
export const getAshasOnIncentives = createSelector(
  [ashasOnIncentives],
  (data) => data
);

export const getIncentiveData = createSelector([incentiveData], (data) => data);

export const getGlobalAreaType = createSelector(
  [globalAreaType],
  (data) => data
);
export const getTotalAshaAnmTableList = createSelector(
  [totalAshaAnmTableList],
  (data) => data
);
export const totalAshaAnmPaginationData = createSelector([paginationData], (data) => data);
export const getAshaByRegionData = createSelector(
  [ashaDeployedTable],
  (data) => {
    return data; // Return the data
  }
);
export const getActiveInactiveAshaAnmCount = createSelector(
  [ashaAnmActiveInactiveCount],
  (data) => data
);
export const getIsDataLoading = createSelector([isDataLoading], (data) => data);
